import { useState } from 'react';

/**
 * Hook personalizado para manejar el envío de formularios
 * @param {string} tipoFormulario - Tipo de formulario (upeace, contacto, congreso, editorial)
 * @returns {object} - Estado y funciones para manejar el formulario
 */
export const useFormSubmit = (tipoFormulario) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const submitForm = async (formData) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      // Agregar el tipo de formulario a los datos
      const dataToSend = {
        ...formData,
        tipo_formulario: tipoFormulario
      };

      // Enviar al API PHP
      const response = await fetch('/api/send-email.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend),
      });

      // Parse response safely: some server errors may return empty body or non-JSON
      const text = await response.text();
      let result = null;
      if (text) {
        try {
          result = JSON.parse(text);
        } catch (parseErr) {
          // No JSON in response
          throw new Error('Respuesta inválida del servidor');
        }
      }

      if (response.ok && result && result.success) {
        setSuccess(true);
        return { success: true, message: result.message };
      } else {
        const serverMessage = result && result.message ? result.message : `Error del servidor (${response.status} ${response.statusText})`;
        throw new Error(serverMessage);
      }
    } catch (err) {
      const errorMessage = err.message || 'Error de conexión. Por favor intenta nuevamente.';
      setError(errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setSuccess(false);
    setError(null);
  };

  return {
    loading,
    success,
    error,
    submitForm,
    resetForm
  };
};
